import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { EditWaterPoolBalanceDialog, EditWaterPoolDialog, EditPreventionManualDialog } from '@risk'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import EditIcon from '@material-ui/icons/Edit'
import { Grid, Button, Typography } from '@material-ui/core'
import RefreshButton from '@miscs/refresh-button'
import PfSubPfSelect from '@select/pf-sub-pf-select'
import Table from '@tables/table'
const COMPONENT_GROUP = 'default_rtp_setting'

class WaterPoolPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'WaterPoolPage')
        }
        const pfIDList = []
        Object.entries(this.props.dataService.pfSubPfMap).forEach(([_, elem]) => {
            if (!pfIDList.includes(elem['pf_id'])) pfIDList.push(elem['pf_id'])
        })

        this.pfSelectOption.extraPfSubPfList = {}

        pfIDList.forEach((pfID) => {
            const publicPfSubPfID = utils.ComposePublicPfSubPfId(pfID)

            this.pfSelectOption.extraPfSubPfList[publicPfSubPfID] = {
                is_active: true,
                name: this.t('publicGame'),
                pf_id: pfID,
                pf_sub_pf_id: publicPfSubPfID,
            }
        })
    }

    state = { gameRiskInfoList: {} }

    columns = [
        {
            field: 'pf_sub_pf_id',
            type: 'platform',
        },
        {
            field: 'oid',
        },
        {
            field: 'game_code',
        },
        {
            field: 'game_name',
            translate: {
                dataKey: 'game_code',
                tranKey: 'GameName',
            },
        },
        {
            field: 'balance',
            type: 'currency',
        },
        {
            field: 'setWaterpoolBalance',
            render: (rowData) => {
                return (
                    <Button style={{ minWidth: '72px' }} onClick={() => this.editBalanceDialog.OpenDialog(rowData)} color="primary">
                        <EditIcon />
                        {this.t('edit')}
                    </Button>
                )
            },
        },
        {
            field: 'threshold_prevention_red',
            type: 'currency',
            render: (rowData, display) => {
                let style = {}
                if (rowData.balance < rowData.threshold_prevention_red) {
                    style = {
                        backgroundColor: 'red',
                    }
                }
                return <Typography style={style}>{display}</Typography>
            },
        },
        {
            field: 'threshold_prevention_yellow',
            type: 'currency',
            render: (rowData, display) => {
                let style = {}
                if (rowData.balance < rowData.threshold_prevention_yellow) {
                    style = {
                        backgroundColor: 'yellow',
                    }
                }
                return <Typography style={style}>{display}</Typography>
            },
        },
        {
            field: 'tip_rate',
            render: (rowData) => rowData.tip_rate + '%',
        },
        {
            field: 'setWaterpool',
            render: (rowData) => {
                return (
                    <Button style={{ minWidth: '72px' }} onClick={() => this.editDialog.OpenDialog(rowData)} color="primary">
                        <EditIcon />
                        {this.t('edit')}
                    </Button>
                )
            },
        },
    ]

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.columns.push({
                field: 'preventionManual',
                render: (rowData) => {
                    return (
                        <Button
                            style={{ minWidth: '72px' }}
                            onClick={() => this.editPreventionManualDialog.OpenDialog(rowData)}
                            color="primary"
                            disabled={RISKMGT.BAN_SCORE_NOT_SUPPORT.includes(rowData.oid)}>
                            <EditIcon />
                            {!RISKMGT.BAN_SCORE_NOT_SUPPORT.includes(rowData.oid)
                                ? rowData.expired_date_prevention_manual > utils.datetimeToUnix(utils.currentDatetime())
                                    ? this.t('enabled')
                                    : this.t('expired')
                                : this.t('notSupport')}
                        </Button>
                    )
                },
            })
        }
    }


    pfSelectOption = {
        hideAllSubPlatform: true,
        subPfChangeCallback: () => {
            this.queryData()
        },
        hideCurrency: true,
    }

    queryGameRiskInfoList = (callback, failCallback) => {
        utils.apiRequest(
            'get',
            API.RISKMGT_GAME_RISK_INFO_LIST,
            {
                risk_label_list: [
                    RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_MANUAL,
                    RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_RED,
                    RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_YELLOW,
                ].join(),
                pf_sub_pf_id: this.pfSelect.state.pfSubPfId,
            },
            (data) => {
                this.setState({ gameRiskInfoList: data }, callback)
            },
            (_err) => {
                this.setState({ gameRiskInfoList: {} }, failCallback)
            },
            true
        )
    }

    queryData() {
        this.table.SetLoading(true)

        this.queryGameRiskInfoList(
            () => {
                utils.apiRequest(
                    'get',
                    API.RISKMGT_WATERPOOL_LIST,
                    {
                        pf_id: this.pfSelect.state.pfId !== 'all' ? this.pfSelect.state.pfId : '',
                        pf_sub_pf_id: this.pfSelect.state.pfSubPfId,
                    },
                    (data) => {
                        const tempList = []
                        for (const idx in data) {
                            var temp = utils.deepCopy(data[idx])

                            tempList.push(temp)
                        }

                        this.table.SetData(tempList)
                    },
                    (_err) => {
                        this.table.SetData([])
                    },
                    true
                )
            },
            () => {
                this.table.SetData([])
            }
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <PfSubPfSelect onRef={(ref) => (this.pfSelect = ref)} options={this.pfSelectOption}></PfSubPfSelect>
                <Grid item xs={7}></Grid>
                <RefreshButton callback={() => this.queryData()}></RefreshButton>
                <Grid item xs={12}>
                    <Table
                        ownerName="WaterPoolPage"
                        columns={this.columns}
                        options={{
                            orderIdx: 1,
                        }}
                        onRef={(ref) => (this.table = ref)}
                    />
                    <EditWaterPoolBalanceDialog
                        confirmCallback={() => {
                            this.queryData()
                        }}
                        onRef={(ref) => (this.editBalanceDialog = ref)}
                        owner={this.state}
                    />
                    <EditWaterPoolDialog
                        confirmCallback={() => {
                            this.queryData()
                        }}
                        onRef={(ref) => (this.editDialog = ref)}
                        owner={this.state}
                    />
                    <EditPreventionManualDialog
                        confirmCallback={() => {
                            this.queryData()
                        }}
                        onRef={(ref) => (this.editPreventionManualDialog = ref)}
                        owner={this.state}
                    />
                </Grid>
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {}
}

WaterPoolPage.propTypes = {
    classes: PropTypes.object.isRequired,
    dataService: PropTypes.object,
}

export default hoc(styles)(WaterPoolPage)
